import HeaderAffida from "../../components/header/HeaderAffida";
import ConfirmAnimation from "../../components/lotties/confirm";
import timbro from "../../assets/svg/timbro_approval.svg";
import oam from "../../assets/OAM Affida - IMG.png";
import talk from "../../assets/svg/talkative.svg";
import style from "./ThankYouLpAgente.module.css";
import React, { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import HorizontalSeparator from "../../components/horizontal-separetor/HorizontalSeparetor";
import { Footer } from "../../components/footer/Footer";
import MaskedImage from "../../components/masked-image/MaskedImage";

interface ThankYouState {
  nome?: string;
  cognome?: string;
  consulente?: string;
  photoURL?: string;
}

const ThankYouLpAgente: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const state = location.state as ThankYouState | null;

  const nome = state?.nome;
  const cognome = state?.cognome;
  const consulente = state?.consulente;
  const photoURL = state?.photoURL;

  const channel = searchParams.get("channel");
  const lp = searchParams.get("lp");

  useEffect(() => {
    console.log("lp agente ty", state);
  }, []);

  return (
    <div>
      <HeaderAffida />
      <div className={style.thankYouContainer}>
        <div className={style.tyContainer}>
          <div className={`container ${style.tyContainer}`}>
            <div className={style.box}>
              {photoURL ? (
                <MaskedImage
                  x={-100}
                  y={0}
                  wContainer={280}
                  wImage={460}
                  hImage={300}
                  dPath={"dPath3"}
                  wSvg={260}
                  hSvg={260}
                  imgURL={
                    photoURL
                      ? photoURL
                      : "https://firebasestorage.googleapis.com/v0/b/ws-digital-3abf0.firebasestorage.app/o/consulente_img.png?alt=media&token=fb42f2cb-2e1e-437b-ba73-40dc428477a1"
                  }
                />
              ) : (
                <ConfirmAnimation />
              )}
            </div>
            <div className={style.box}>
              <span style={{ fontWeight: 200, fontSize: "16px" }}>
                COMPLIMENTI
              </span>
              <h2 style={{ marginTop: "0.35em", marginBottom: ".5em" }}>
                {nome
                  ? `${nome} ${cognome}, grazie per averci scelto!`
                  : "Grazie per averci scelto!"}
              </h2>

              <p>
                {consulente
                  ? `${consulente} o un membro del suo team, ti contatterà al più presto per la consulenza.`
                  : "Un consulente Affida ti contatterà al più presto."}
              </p>

              {/* utile per debug o tracking */}
              {/* <small>channel: {channel} | lp: {lp}</small> */}
            </div>
          </div>
        </div>
        <div
          className={style.tyContainer}
          style={{ backgroundColor: "#fefefe" }}
        >
          <div className={`container ${style.tyContainer}`}>
            <div className={style.box}>
              <div className={style.boxChild}>
                <span style={{ fontWeight: 200, fontSize: "16px" }}>
                  IMPORTANTE
                </span>
                <h2 style={{ marginTop: "-0.35em" }}>
                  Prepariamo al meglio il nostro appuntamento!
                </h2>
                <span>Avrai bisogno dei seguenti documenti:</span>
                <ul style={{ listStyle: "none" }}>
                  <li>✅ Carta identità e tessera sanitaria</li>
                  <li>✅ Ultima Certificazione Unica</li>
                  <li>✅ Ultime 2 Buste Paga</li>
                </ul>
              </div>
            </div>
            <div className={style.box}>
              <div className={style.boxChild}>
                <img src={timbro} alt="timbro" className={style.imgBox} />
              </div>
            </div>
          </div>
        </div>

        <div className={style.tyContainer}>
          <div className={`container ${style.tyContainer}`}>
            <div className={style.box}>
              <div className={style.boxChild}>
                <div className={style.boxChild}>
                  <img src={talk} alt="talk" className={style.imgBox} />
                </div>
              </div>
            </div>
            <div className={style.box}>
              <div className={style.boxChild}>
                <div className={style.boxChild}>
                  <span style={{ fontWeight: 200, fontSize: "16px" }}>
                    PERCHÈ AFFIDA
                  </span>
                  <h2 style={{ marginTop: "-0.35em" }}>
                    Semplifichiamo la burocrazia e ottimizziamo i tempi!
                  </h2>
                  <span>Le attività che faremo per te:</span>
                  <ul style={{ listStyle: "none" }}>
                    <li>✅ Individuare il prodotto migliore</li>
                    <li>✅ Gestire i flussi burocratici</li>
                    <li>✅ Coordinare le attività fino all'erogazione</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={style.tyContainer}
          style={{ backgroundColor: "#fefefe" }}
        >
          <div className={`container ${style.tyContainer}`}>
            <div className={style.box}>
              <div
                className={style.boxChild}
                style={{ justifyContent: "center" }}
              >
                <span style={{ fontWeight: 200, fontSize: "16px" }}>
                  LEGALITÀ
                </span>
                <h2 style={{ marginTop: "-0.35em" }}>
                  Affida è una società autorizzata ad operare!
                </h2>
                <span>
                  Siamo iscritti presso l'organismo Agenti e Mediatori:
                </span>
                <ul style={{ listStyle: "none" }}>
                  <li>✅ Sottoposti a sorveglianza da parte di OAM</li>
                  <li>✅ Requisiti di idoneità ad operare</li>
                  <li>✅ Consulenti iscritti presso l'organismo</li>
                </ul>
              </div>
            </div>
            <div className={style.box}>
              <div className={style.boxChild}>
                <img
                  src={oam}
                  alt="talk"
                  className={style.imgBox}
                  style={{ maxWidth: "125px", scale: 1 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ThankYouLpAgente;
